import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface Props {
  onImportClick: () => void;
  onResetClick: () => void;
  onToMaintenanceClick: () => void;
}

export function MstImportFooterButtons(props: Props) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('startImport')} onClick={props.onImportClick} />
      <Button label={getButtonName('reset')} onClick={props.onResetClick} />
      <Button label={getButtonName('toMaintenance')} onClick={props.onToMaintenanceClick} />
    </ButtonGroup>
  );
}
